"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.TYPE = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _ContentEntity2 = _interopRequireDefault(require("./ContentEntity"));

var _StringHelper = _interopRequireDefault(require("../../helpers/StringHelper"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var TYPE = 'lecture';
exports.TYPE = TYPE;

var Lecture = /*#__PURE__*/function (_ContentEntity) {
  (0, _inherits2["default"])(Lecture, _ContentEntity);

  var _super = _createSuper(Lecture);

  function Lecture(json) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, Lecture);
    _this = _super.call(this, json);
    _this.subtype = json.subtype;
    _this.idtag = json.idtag;
    _this.title = _StringHelper["default"].decodeHtmlEntities(json.title);
    _this.subtitle = _StringHelper["default"].decodeHtmlEntities(json.subtitle);
    _this.nuggetIds = json.nuggets;
    _this.icon = json.icon;
    _this.enhancedIcon = json.enhancedIcon;
    _this.svgIcon = json.svg_icon;
    _this.enhancedSvgIcon = json.enhancedSvgIcon;
    _this.newSvgIcon = json.new_svg_icon;
    _this.enhancedNewSvgIcon = json.enhancedNewSvgIcon;
    _this.template = json.template;
    _this.theme = json.theme;
    _this.keyword = json.keyword;
    _this.arrowColor = json.arrowColor;
    _this.backgroundColor = json.backgroundColor;
    _this.verticalBannerColor = json.verticalBannerColor;
    _this.fontColor = json.fontColor;
    _this.background = json.background;
    _this.enhancedBackground = json.enhancedBackground;
    _this.enhancedBackgroundColored = json.enhancedBackgroundColored;
    _this.enhancedBannerImage = json.enhancedBannerImage;
    _this.unhighlightCondition = json.unhighlightCondition;
    _this.processTime = json.processTime;
    _this.active = json.active;
    _this.flexLink = json.flexLink;
    _this.externalURL = json.externalUrl;
    _this.isPublished = json.published;
    _this.rubrics = json.rubrics;
    _this.hideContinueArrow = json.hideContinueArrow;
    _this.innerBackgroundColor = json.innerBackgroundColor;
    _this.pushMessageText = json.pushmessagetext;
    _this.pushTitleText = json.pushtitletext;
    _this.order = json.order;
    _this.showNewBanner = json.shownewbanner;
    _this.hideLikeFeature = json.hidelikefeature;
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(Lecture.prototype)), "activateTrackings", _thisSuper).call(_thisSuper);
    return _this;
  }

  return Lecture;
}(_ContentEntity2["default"]);

var _default = Lecture;
exports["default"] = _default;